import Layout from "../../../components/Layout";
import uploadArchive from "../Dashboard";

export default function Arquivos() {
  return Layout(uploadArchive, "Arquivos");
}
